"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileNameWithoutExtension = exports.getShortFileName = void 0;
var constants_1 = require("../constants");
function getShortFileName(fileName) {
    var name = fileName;
    var nameLength = name.length;
    if (nameLength > constants_1.FILE_NAME_MAX_LENGTH) {
        var startStr = name.substring(0, constants_1.FILE_NAME_FIRST_SUBSTRING_LENGTH).trim();
        var lastStr = name.substring(nameLength - constants_1.FILE_NAME_LAST_SUBSTRING_LENGTH, nameLength).trim();
        return startStr.concat(constants_1.FILE_NAME_SHORT_NAME_SEPARATOR).concat(lastStr);
    }
    return name;
}
exports.getShortFileName = getShortFileName;
function getFileNameWithoutExtension(fileName) {
    return fileName.replace(/\.[^/.]+$/, '');
}
exports.getFileNameWithoutExtension = getFileNameWithoutExtension;
